import React from "react";
import { Amplify } from "aws-amplify";
import { ThemeProvider, defaultTheme, Authenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import Dashboard from "../../dashboard";
import awsExports from "../../../../src/aws-exports";

Amplify.configure(awsExports);

export default function App() {
  // Custom theme
  const customTheme = {
    ...defaultTheme,
    name: "custom-theme",
    tokens: {
      colors: {
        brand: {
          primary: { value: "#6C63FF" }, // Change primary color
          secondary: { value: "#FF6584" },
        },
      },
      components: {
        button: {
          primary: {
            backgroundColor: { value: "#6C63FF" },
            color: { value: "#FFFFFF" },
          },
        },
      },
    },
  };

  return (
    <ThemeProvider theme={customTheme}>
      <Authenticator
        initialState="signIn" // Set default state to sign-in
        hideSignUp={true} // Completely hide the Sign-Up option
        components={{
          Header: () => (
            <div style={{ textAlign: "center", marginBottom: "20px" }}>
              <h1 style={{ color: "#6C63FF", fontSize: "2rem" }}>Welcome to Blue Parking</h1>
              <p style={{ color: "#7a7a7a" }}>Log in to continue</p>
            </div>
          ),
        }}
      >
        {({ signOut, user }) => <Dashboard />}
      </Authenticator>
    </ThemeProvider>
  );
}
